module.exports = __webpack_public_path__ + "static/Greta-Exam-Results-Day-0a4b6cd74605e4ae14de06d632825a21.mp4";